module.exports = __webpack_public_path__ + "svg/social-yandex.svg?448eae46b734f861e6f7a65a3264c38e";